import React from 'react'
import { t } from '@lingui/macro'
import { GroupModelGqlBase } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import {
  EntitiesFilterModal,
  ModalFilterEntitiesEnum
} from '../../../components/common/entityFiltersModals'

export type FilterGroupModalProps = {
  onChange: (groupIds: number[]) => void
  selectedGroupIds: number[]
  groups: Required<
    Pick<GroupModelGqlBase, 'id' | 'name' | 'usersCount' | '__typename'>
  >[]
}

export const FilterGroupModal: React.FC<FilterGroupModalProps> = ({
  selectedGroupIds,
  groups,
  onChange
}) => {
  return (
    <EntitiesFilterModal
      entityType={'groups'}
      header={t`Groups`}
      modalId={ModalFilterEntitiesEnum.GROUP}
      subHeader={t`Filter to include only reports by members of 1 or more groups:`}
      selectedIds={selectedGroupIds}
      setSelectedIds={onChange}
      entities={groups}
    />
  )
}
